<template>
  <div :style="{ width: '700px' }">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <system-linked-combo v-model="select" hide-stack></system-linked-combo>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="ml-2 mt-1" x-small color="primary" @click="fetchData(1)" @click.ctrl.alt="fetchData(0)">
              <v-icon small>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('common.retrieve') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <!-- eslint-disable-next-line prettier/prettier -->
    <v-data-table
      :headers="headers" :items="items" item-key="sequence" :loading="loading"
      class="elevation-1 content" dense fixed-header disable-pagination hide-default-footer height="560px"
    >
      <template v-slot:top>
        <AlertUser ref="alertUserComp" :userFormData="checkedItem" dscType="userChange" />
      </template>
      <template v-slot:item.active="{ item }">
        <v-simple-checkbox v-model="item.active" class="check-margin" @click="checkActive(item)"></v-simple-checkbox>
      </template>
      <template v-if="fetchAll" v-slot:item.display="{ item }">
        <v-simple-checkbox v-model="item.display" class="check-margin" @click="checkDisplay(item)"></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn v-if="item.active" x-small max-height="20" @click="openAlertUser(item)">
          <v-icon small left color="primary">mdi-bell-plus-outline</v-icon>
          <span v-html="$t('alert.user.settings')" />
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import AlertUser from './components/AlertUser';

export default {
  components: {
    AlertUser,
  },
  data() {
    return {
      loading: true,
      select: { stack: 'ABAP', system: '' },
      items: [],
      checkedItem: {},
      headerBase: [
        { text: this.$t('alert.description'), value: 'message', width: '50%', sortable: false },
        { text: this.$t('alert.active'), value: 'active', sortable: false, align: 'center' },
      ],
      headerDisplay: [{ text: this.$t('alert.display'), value: 'display', sortable: false, align: 'center' }],
      headerAction: [{ text: '', value: 'actions', width: '20%', sortable: false }],
      fetchAll: false,
    };
  },
  computed: {
    headers() {
      if (this.fetchAll) return [...this.headerBase, ...this.headerDisplay, ...this.headerAction];
      else return [...this.headerBase, ...this.headerAction];
    },
  },
  watch: {
    select: {
      deep: true,
      handler() {
        this.fetchData(1);
      },
    },
  },
  methods: {
    /**
     * . 조회 버튼을 그냥 클릭 시에는
     *   dsplOptn에 'D'가 전달되어 서버에서 CONF_ALRT_CODE.IS_DSPL='1'인 내역만 읽어준다.
     * . 조회 버튼 클릭 시 Ctrl+Alt를 누르고 클릭하면 모든 내역을 다 읽어준다.
     *   이는 OWLens 기술지원 인력이 필요에 따라
     *   코드 내역을 이 화면에 표시해줄 지 여부를 편집할 수 있게 하기 위한 기능이다.
     *   또한, dspl 조건으로 0이 설정된 경우에는 목록에서 "표시여부(IS_DSPL)" 컬럼을 보여주고
     *   check-box가 클릭될 때 바로 해당 내역의 IS_DSPL 컬럼 값을 DB에서 변경하여 준다.
     * . 사실 이 화면은 조회 버튼이 필요없는데 위와 같은 기능 구현을 위해 존재한다.
     */
    async fetchData(dspl) {
      this.loading = true;
      this.fetchAll = dspl == 0 ? true : false;
      const params = {
        stackType: this.select.stack,
        systemId: this.select.system,
        display: dspl,
      };
      const { data } = await api.get('/preference/user-change', { params });
      // Description 값으로 정렬을 해주어서 어떤 locale에서든 목록 탐색 용이성을 부여한다.
      data.sort((a, b) => a.message.localeCompare(b.message));
      this.items = data;
      this.loading = false;
    },
    async checkActive(item) {
      const param = new URLSearchParams();
      param.append('systemId', item.systemId);
      param.append('sapDataCode', item.sapDataCode);
      param.append('alertCode', item.alertCode);
      param.append('active', item.active);
      const rspn = await api.post('/preference/update-alert-code-is-active', param);
      if (rspn.status == 200) {
        if (item.active) {
          this.$dialog.info(this.$t('common.activate.success'));
        } else {
          this.$dialog.info(this.$t('common.deactivate.success'));
        }
      }
    },
    async checkDisplay(item) {
      const param = new URLSearchParams();
      param.append('systemId', item.systemId);
      param.append('sapDataCode', item.sapDataCode);
      param.append('alertCode', item.alertCode);
      param.append('display', item.display);
      const rspn = await api.post('/preference/update-alert-code-is-display', param);
      if (rspn.status == 200) {
        this.$dialog.info(this.$t('common.successful'));
      }
    },
    openAlertUser(item) {
      this.checkedItem = item;
      this.$refs.alertUserComp.$data.userShow = true;
    },
  },
};
</script>
<style lang="scss">
.check-margin {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0;
  .v-input--selection-controls__input {
    margin: 0 auto !important;
  }
}
</style>
